import THDStorageUtils, { LOCAL_STORAGE } from '@thd-olt-global/thd-storage-utils';
import {
  SEARCH_HISTORY_STORAGE_KEY, ERROR,
} from './AddToConstants';

const {
  EMPTY_GROUP_NAME_MESSAGE,
  INVALID_GROUP_LENGTH_MESSAGE,
  INVALID_PROJECT_TEXT_MESSAGE
} = ERROR;
export const fetchSearch = () => {
  try {
    const history = THDStorageUtils.get(LOCAL_STORAGE, { key: SEARCH_HISTORY_STORAGE_KEY });
    if (!history || history === 'undefined') {
      return [];
    }
    const parsedHistory = JSON.parse(history);
    return Array.isArray(parsedHistory) ? parsedHistory.slice(0, 10) : [];
  } catch (err) {
    // Handle both storage access errors and JSON parsing errors
    console.error('Error retrieving search history:', err);
    return [];
  }
};

export const searchHystoryFormat = (data) => {
  return data?.map(({ keyword }) => {
    const cleanKeyword = decodeURIComponent(keyword) || keyword;
    return ({ link: `/s/${keyword}`, title: cleanKeyword });
  });
};

export const generateLoadedProducts = (existingProducts, newProducts) => {
  const existingItemIds = existingProducts.map((product) => product.itemId);
  const productsToLoad = newProducts?.filter((product) => !existingItemIds.includes(product.id)) || [];
  return [...existingProducts, ...productsToLoad];
};

export const getNvalue = (path) => {
  const pathArr = path.split('/');
  const fullNValue = pathArr.find((part) => part.startsWith('N-') || part.startsWith('Ntt-'));
  if (fullNValue) {
    const nValue = fullNValue.split('?')?.[0];
    if (nValue.startsWith('N-')) {
      return nValue.slice(2);
    }
    return nValue.slice(4);
  }
  return null;
};

export const triggerAnalytics = (event, payload) => {
  LIFE_CYCLE_EVENT_BUS.trigger(event, payload);
};

export const addNonQuotableProductVariables = (product) => {
  const { identifiers, info } = product || {};

  const isMajorAppliance = identifiers?.productType === 'MAJOR_APPLIANCE';
  if (isMajorAppliance) {
    return {
      isQuotable: false,
      notQuotableLabel: 'Major appliances'
    };
  }

  const isConfigurableBlinds = identifiers?.productType === 'CONFIGURABLE_BLINDS';
  if (isConfigurableBlinds) {
    return {
      isQuotable: false,
      notQuotableLabel: 'GCC configurators'
    };
  }

  const isLiveGoods = info?.isLiveGoodsProduct;
  if (isLiveGoods) {
    return {
      isQuotable: false,
      notQuotableLabel: 'Live goods'
    };
  }

  return {};
};

export const validateGroupName = (value) => {
  const validCharacters = /^(?=.{0,50}$)[ [\]{}|a-z|A-Z|!@#$%^&*()0-9-_+,.?"':;\\]+$/;
  const blank = !(value || '').replace(/\s/g, '');
  let isValid = validCharacters.test(value);
  const charLimit = value?.length > 50;
  let errorMessage = '';
  if (!isValid) {
    if (blank) {
      errorMessage = EMPTY_GROUP_NAME_MESSAGE;
    } else if (charLimit) {
      errorMessage = INVALID_GROUP_LENGTH_MESSAGE;
    } else {
      errorMessage = INVALID_PROJECT_TEXT_MESSAGE;
    }
  }
  return { isError: !isValid, errorMessage };
};

export const getProductsByType = (products) => {
  if (!products?.length) {
    return {
      qcProducts: [],
      nonSharedQcProducts: [],
      majorAppliances: [],
      configurableBlinds: [],
      liveGoods: [],
      discontinuedOutOfStockUnavailable: [],
    };
  }

  return {
    qcProducts: products.filter((product) => product.flag === 'QC_PRODUCT'),
    nonSharedQcProducts: products.filter((product) => product.flag === 'NON_SHARED_QC_PRODUCT'),
    majorAppliances: products.filter((product) => product.flag === 'MAJOR_APPLIANCE'),
    configurableBlinds: products.filter((product) => product.flag === 'CONFIGURABLE_BLINDS'),
    liveGoods: products.filter((product) => product.flag === 'LIVE_GOODS'),
    discontinuedOutOfStockUnavailable: products.filter((product) => product.flag === 'DISCONTINUED_OOS_UNAVAILABLE'),
  };
};

export const formatProductsforCopy = (products) => {
  return products.map((product) => (
  `Product: ${product?.identifiers?.productLabel || product?.product?.description || 'N/A'}\n\
  SKU: ${product?.identifiers?.storeSkuNumber || product?.product?.sku || 'N/A'}\n\
  Brand: ${product?.identifiers?.brandName || 'N/A'}\n\
  Quantity: ${product?.quantity || product?.product?.quantity || 'N/A'}\n\
  itemId: ${product?.itemId || 'N/A'}\n\
  Type: ${product?.flag}`
  )).join('\n\n');
};

const filterNonQuoteableCatalogProducts = (productsData) => {
  if (!productsData) {
    return [];
  }
  const filteredProducts = productsData.filter((product) => {
    return (
      product?.flag === 'MAJOR_APPLIANCE'
      || product?.flag === 'CONFIGURABLE_BLINDS'
      || product?.flag === 'LIVE_GOODS'
      || product?.flag === 'DISCONTINUED_OOS_UNAVAILABLE'
    );
  });
  return filteredProducts;
};

export const updateNonQuoteableProducts = (catalogItem, qCItems, nonSharedQCItems) => {
  const newProducts = [];
  if (qCItems?.length) {
    newProducts.push(...qCItems);
  }
  if (nonSharedQCItems?.length) {
    newProducts.push(...nonSharedQCItems);
  }
  if (catalogItem?.length) {
    const filteredProducts = filterNonQuoteableCatalogProducts(catalogItem);
    newProducts.push(...filteredProducts);
  }
  return newProducts;
};

export const handleOpenATQ = (buttonRef) => {
  if (buttonRef.current) {
    buttonRef.current.click();
  }
};

export const triggerLoadingDrawerAnalytics = (message, startTime) => {
  const elapsedSeconds = Math.floor(Date.now() / 1000) - startTime;
  window.LIFE_CYCLE_EVENT_BUS.trigger('add-to-quote.closeLoadingScreen',
    { settings: `add to quote loading screen overlay: ${message}: ${elapsedSeconds}` }
  );
};